<template>
  <div ref="hcaptcha" :data-callback="'hCaptchaResponse' + uid"></div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
export default {
  props: {
    sitekey: {
      type: String,
    },
    language: {
      type: String,
    },
  },
  data() {
    return {
      uid: uuidv4(),
      id: null,
      token: "",
    };
  },
  methods: {
    reset() {
      window.hcaptcha.reset(this.id);
    },
  },
  mounted() {
    window["hCaptchaResponse" + this.uid] = () => {
      this.token = window.hcaptcha.getResponse(this.id);
      this.$emit("verify", this.token);
    };
    this.id = window.hcaptcha.render(this.$refs.hcaptcha, {
      sitekey: this.sitekey,
      hd: this.language,
      language: this.language,
    });
  },
  beforeUnmount() {
    this.$refs.hcaptcha.remove();
    window["hCaptchaResponse" + this.uid] = null;
  },
};
</script>

